import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'carita',
  templateUrl: './carita.component.html',
  styleUrls: ['./carita.component.scss'],
})
export class CaritaComponent implements OnInit {
  @Input() setValue: any
  @Input() setFace: string
  @Input() setPregunta: string
  @Input() elID: string
  @Output() valueEmit = new EventEmitter<object>()

  public faces = {
    sad : './assets/icon/sad-face-icon.svg',
    normal : './assets/icon/normal-face-icon.svg',
    happy : './assets/icon/happy-face-icon.svg'
  }

  recibeClick( event: any ) {
    const target = event.target || event.srcElement || event.currentTarget
    this.pintaCaritas(target.id)
    this.emitValue()
  }

  pintaCaritas(id: string) {
    if (id.search('sad') > 1) {
      const idSinCara = id.split('sad', 2)[0]
      document.getElementById(id).setAttribute('style', 'opacity: 1 !important;')
      document.getElementById(idSinCara + 'normal').setAttribute('style', 'opacity: .5 !important;')
      document.getElementById(idSinCara + 'happy').setAttribute('style', 'opacity: .5 !important;')
    } else if (id.search('normal') > 1) {
      const idSinCara = id.split('normal', 2)[0]
      document.getElementById(id).setAttribute('style', 'opacity: 1 !important;')
      document.getElementById(idSinCara + 'sad').setAttribute('style', 'opacity: .5 !important;')
      document.getElementById(idSinCara + 'happy').setAttribute('style', 'opacity: .5 !important;')
    } else if (id.search('happy') > 1) {
      const idSinCara = id.split('happy', 2)[0]
      document.getElementById(id).setAttribute('style', 'opacity: 1 !important;')
      document.getElementById(idSinCara + 'normal').setAttribute('style', 'opacity: .5 !important;')
      document.getElementById(idSinCara + 'sad').setAttribute('style', 'opacity: .5 !important;')
    }
  }

  emitValue() {
    const objeto = {valor: this.setValue, face: this.setFace, pregunta: this.setPregunta}
    this.valueEmit.emit(objeto)
  }


  ngOnInit() {
    this.elID += this.setFace
  }
}
